import { ReactNode } from 'react';
import styled from 'styled-components';
import { css } from 'styled-components';

import { zIndex } from '@/constants/zIndex';
import { ClientType } from '@/types/app';
import { HeaderType } from '@/types/header';

const Wrapper = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;

  & > * {
    &:first-child {
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const TemplateHeader = styled.header<{
  useSafeArea?: boolean;
  position?: 'sticky' | 'static';
  height?: number;
}>`
  position: ${({ position }) => (position ? position : 'sticky')};
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  width: 100%;
  top: 0;

  ${({ theme, useSafeArea }) => `
      background-color: ${theme.color.white};
      border: 0px solid ${useSafeArea ? 'red' : 'green'};
  `};

  ${({ theme, useSafeArea, height }) => {
    const {
      client: { clientType, isAndroid },
    } = theme;
    const headerHeight = height ?? 60;
    switch (clientType) {
      case ClientType.MOBILE_WEBVIEW:
        if (isAndroid) {
          return `
            height: ${headerHeight}px;
          `;
        }
        return `
          height: ${useSafeArea ? headerHeight : 100}px;
        `;
      case ClientType.WEB:
        return `
          height: ${headerHeight}px;
        `;
      case ClientType.MOBILE_WEB:
        return `
          height: ${headerHeight}px;
          top: 60px;
        `;
      default:
        return `
            height: ${0}px;
          `;
    }
  }};
`;

const StickyTemplateHeader = styled.header<{ type?: HeaderType }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  width: 100%;
  z-index: ${zIndex.AppHeader};
  position: sticky;
  ${({ type, theme }) => {
    switch (type) {
      case HeaderType.WithMobileHeader: {
        return css`
          top: ${[ClientType.WEB, ClientType.MOBILE_WEBVIEW].includes(
            theme.client.clientType,
          )
            ? 0
            : 60}px;
        `;
      }
      default:
        return css`
          top: 0px;
        `;
    }
  }}
`;

const Content = styled.section`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const StickyBottom = styled.section`
  width: 100%;
  z-index: ${zIndex.BottomSticky};
  position: sticky;
  bottom: 0;
  padding: 32px 20px 20px;
  background-color: ${({ theme }) => theme.color.white};
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 30%,
    rgba(255, 255, 255, 1) 100%
  );
`;

// eslint-disable-next-line @typescript-eslint/no-empty-function
const TemplateLayout = () => {};

const Header = (props: {
  children?: ReactNode;
  useSafeArea?: boolean;
  position?: 'sticky' | 'static';
  height?: number;
}) => (
  <TemplateHeader
    useSafeArea={props.useSafeArea}
    position={props.position}
    height={props.height}
  >
    {props.children}
  </TemplateHeader>
);

const StickyHeader = ({
  children,
  type,
  style,
}: {
  children: ReactNode;
  type?: HeaderType;
  style?: React.CSSProperties;
}) => {
  return (
    <StickyTemplateHeader type={type} style={style}>
      {children}
    </StickyTemplateHeader>
  );
};

TemplateLayout.Wrapper = Wrapper;

/**
 * @deprecated 확장성을 위해 이관예정
 */
TemplateLayout.Header = Header;

TemplateLayout.StickyHeader = StickyHeader;
TemplateLayout.Content = Content;
TemplateLayout.StickyBottom = StickyBottom;
export default TemplateLayout;
